<template>
  <div v-if="isHideRevenue !== undefined" class="wrapper">
    <div v-if="isHideRevenue">本ページへのアクセス権がありません</div>
    <div v-if="!isHideRevenue">
      <div>シミュレーション一覧</div>
      <v-toolbar flat color="transparent">
        <SimulationButtonAdd />
        <v-spacer />
        <SimulationListSearchBox @onTextChange="onTextChange" />
        <PageSelect
          :value="simulationList"
          @input="pagination"
          style="width:200px;"
          class="pl-4"
        />
      </v-toolbar>
      <SimulationList
        @refresh="getSimulationPlanList"
        @changeSort="changeSort"
        :items="simulationList.items"
        :sort-options="sortOptions"
        :loading="loading"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import SimulationList from '@/components/Shared/Simulation/SimulationList.vue'
import SimulationListSearchBox from '@/components/Shared/Simulation/SimulationListSearchBox.vue'
import PageSelect from '@/components/Shared/Search/PageSelect'
import SimulationButtonAdd from '@/components/Shared/Simulation/SimulationListButtonAdd.vue'
import { accountInitializer } from '@/mixins/accountInitializer'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'
import { SimulationPlanRepository } from '@/models/Simulation/SimulationPlanRepository'
import { Account } from '@/models/Account'
import { setSimulationIsRunning } from '@/models/Simulation/setSimulationIsRunning'

export default {
  name: 'Simulation',
  components: {
    SimulationButtonAdd,
    SimulationListSearchBox,
    PageSelect,
    SimulationList,
  },
  mixins: [
    accountInitializer,
    setDrawerTypeAdvertiser,
    setToolbarTypeAdvertiser,
  ],
  data() {
    return {
      searchWord: '',
      pageNo: 1,
      pageSize: 20,
      sortOptions: {
        sortBy: 'updated_time',
        descending: true,
      },
      menuType: 'geo',
      simulationList: {},
      loading: false,
      isHideRevenue: undefined,
    }
  },
  computed: {
    ...mapGetters('currentAdvertiser', ['currentAdvertiser']),
    ...mapGetters('account', ['accountId']),
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    async userBelongType() {
      this.setIsHideRevenue()
    },
  },
  created() {
    this.getSimulationPlanList()
    this.setIsHideRevenue()
  },

  methods: {
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    onTextChange(searchWord) {
      this.searchWord = searchWord
      this.pageNo = 1
      this.getSimulationPlanList()
    },
    pagination(pageNo) {
      this.pageNo = pageNo
      this.getSimulationPlanList()
    },
    changeSort(sortOptions) {
      this.sortOptions = sortOptions
      this.getSimulationPlanList()
    },
    async getSimulationPlanList() {
      this.loading = true
      const apiResponseSimulationList = await SimulationPlanRepository.getSimulationList(
        this.accountId,
        this.currentAdvertiser.id,
        this.searchWord,
        this.menuType,
        this.pageNo,
        this.pageSize,
        this.sortOptions,
      )
      this.simulationList = await setSimulationIsRunning(
        apiResponseSimulationList,
      )
      this.simulationList['pageSize'] = this.pageSize
      this.loading = false
    },
  },
}
</script>

<style scoped>
.wrapper {
  width: 100%;
}
</style>
